module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAABOUlEQVQ4je3UsUtVYRzG8c+Ve1GzQmsL6i9QCMymQoSgNpdAmlrLQQShoElw8Q8Ql6ZotqUlFxdB6NbYXxC56BDe2p+Gey68mAftcqbwCz9efs/58Twv73nPaSW5jne4rVl+4WUbj7CITZw0ZN7GGp630cFPvGnIfMBDdEYaNv2Ly4ChA97iK5YLbRL76GKu0BfwBXsYu2jAY8ziQaHdqvo5TBf6Xdyrgm6cNmrXBLzHfXwstO/4gHF8LvR97Opf9ePTRq0kS9jGzZqwYfmEb//vLWo8YFT9Cx+WqyrTQ0xU6+9ioItnRT+F13iK1jnmHf3f/04rCTzBnWJgsdrBPK5gBa/Qw1a1nkcPO5KcVRtJDpK8SHKY5CjJapLRmvnaqnuwlD69JOtJrv2r8aAGR3QWM/ih/4UOzR/cR8gwa1D19wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhuzhou/icon5.png
// module id = aSx0
// module chunks = 1